import React from 'react';

export default function FrankensteinHatSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      <polygon points="37.58,18.5 35.19,18.5 34.18,14.62 36.57,14.62" fill="#ABB5B3" />
      <polygon points="35.19,18.5 37.58,18.5 35.13,25.43 32.75,25.43" fill="#758481" opacity="0.95" />
      <polygon points="35.19,18.5 32.75,25.43 31.73,21.55 34.18,14.62" fill="#758481" opacity="0.95" />
      <polygon points="34.24,21.19 6.63,21.19 6.63,18.21 34.24,18.21" fill="#ABB5B3" />
      <polygon points="6.63,21.19 34.24,21.19 33.34,20.75 5.74,20.75" fill="#758481" opacity="0.95" />
      <polygon points="6.63,21.19 5.74,20.75 5.74,17.76 6.63,18.21" fill="#758481" opacity="0.95" />
      <polygon points="6.26,25.83 3.87,25.83 5.2,15.84 7.58,15.84" fill="#ABB5B3" />
      <polygon points="3.87,25.83 6.26,25.83 4.94,23.34 2.55,23.34" fill="#758481" opacity="0.95" />
      <polygon points="3.87,25.83 2.55,23.34 3.87,13.36 5.2,15.84" fill="#758481" opacity="0.95" />
      <polygon points="36.83,25.72 34.43,25.72 34.43,14.19 36.83,14.19" fill="#ABB5B3" />
      <polygon points="34.43,25.72 36.83,25.72 35.4,25.0 33.0,25.0" fill="#758481" opacity="0.95" />
      <polygon points="34.43,25.72 33.0,25.0 33.0,13.47 34.43,14.19" fill="#758481" opacity="0.95" />
      <polygon points="7.59,24.67 5.18,24.67 3.86,13.36 6.26,13.36" fill="#ABB5B3" />
      <polygon points="5.18,24.67 7.59,24.67 6.26,25.83 3.86,25.83" fill="#758481" opacity="0.95" />
      <polygon points="5.18,24.67 3.86,25.83 2.54,14.52 3.86,13.36" fill="#758481" opacity="0.95" />
      <polygon points="8.13,20.53 5.74,20.53 5.2,15.84 7.59,15.84" fill="#ABB5B3" />
      <polygon points="5.74,20.53 8.13,20.53 4.94,23.34 2.55,23.34" fill="#758481" opacity="0.95" />
      <polygon points="5.74,20.53 2.55,23.34 2.0,18.66 5.2,15.84" fill="#758481" opacity="0.95" />
      <polygon points="37.83,22.85 35.44,22.85 35.44,18.07 37.83,18.07" fill="#ABB5B3" />
      <polygon points="35.44,22.85 37.83,22.85 34.38,21.12 31.99,21.12" fill="#758481" opacity="0.95" />
      <polygon points="35.44,22.85 31.99,21.12 31.99,16.34 35.44,18.07" fill="#758481" opacity="0.95" />
      <polygon points="7.58,24.67 5.2,24.67 5.74,20.53 8.13,20.53" fill="#ABB5B3" />
      <polygon points="5.2,24.67 7.58,24.67 4.39,18.66 2.0,18.66" fill="#758481" opacity="0.95" />
      <polygon points="5.2,24.67 2.0,18.66 2.55,14.52 5.74,20.53" fill="#758481" opacity="0.95" />
      <polygon points="38.0,23.77 35.61,23.77 33.17,14.4 35.55,14.4" fill="#ABB5B3" />
      <polygon points="35.61,23.77 38.0,23.77 36.99,26.64 34.6,26.64" fill="#758481" opacity="0.95" />
      <polygon points="35.61,23.77 34.6,26.64 32.15,17.27 33.17,14.4" fill="#758481" opacity="0.95" />
    </svg>
  );
}
